<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createTutor" class="ml-2" isAdd :to="{ name: 'CreateTutor' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getTutorData()"
      actionViewRouteLink="TutorDetails"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'TutorList',
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'id', text: vm.$t('tutorId') },
        { value: 'name', text: vm.$t('tutor') },
        { value: 'username', text: vm.$t('account') },
        { value: 'phone', text: vm.$t('phone') },
      ]
      if (this.$validate.allowAction('TutorDetails', this.userType)) {
        headers.push({ value: 'actionView', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateTutor', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getTutorData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }
      this.tableLoading = true

      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
        }

        const selectedSchool = this.gfGetUserSelectedSchool()
        if (selectedSchool > -1) {
          payload['center'] = [selectedSchool]
        }

        const { data, total } = await this.$Fetcher.GetStaffs(payload)
        this.tableData = data
        this.tableItemTotal = total
      } catch (err) {
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: TutorList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getTutorData(false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>
